/* eslint-disable */
import { StyleSheet, Dimensions } from 'react-native'
import { ApplicationStyles ,Fonts} from '../../Themes/'

export default StyleSheet.create({
  ...ApplicationStyles.screen,
  container : {
    flex: 1,
    backgroundColor: '#FFFFFF'
  },
  html:{
    marginBottom: 10
  },
  normalText : {
    fontSize: 14,
   
   
  },
  headerText: {
    fontSize: 18,
    fontFamily: Fonts.style.font.bold
  },
  centerText : {
    textAlign: 'center'
  },
  boldText:{
    fontFamily: Fonts.style.font.bold
  },
  rowDirection: {
    flexDirection: 'row',
    alignItems: 'center',
    margin: 10
  },
  image : {
    width: Dimensions.get('window').width,
    height: 300
  },
  imageOnline : {
    width: 20,
    height: 20,
    marginRight: 10
  }
})
